import React from "react";
import "./CustomToggleSelector.css";

/**
 * --------------------------------------------------------------------------
 * Component Name : CustomToggleSelector.jsx
 * Created By     : Sreeraj
 * Description    : A  toggle selector (external CSS version)

 * --------------------------------------------------------------------------
 */

const CustomToggleSelector = ({ options = [], selectedValue, onChange }) => {
    return (
        <div className="toggle-container">
            <div className="toggle-group">
                {options.map((item) => (
                    <div
                        key={item.value}
                        className={`toggle-item ${selectedValue === item.value ? "active" : ""
                            }`}
                        onClick={() => onChange(item.value)}
                    >
                        {item.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CustomToggleSelector;
